<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5H6NDE/tc-custom/9781631952067.jpg?1736221293501" alt="This image is the cover for the book Soul Modes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Soul Modes
      </h1>
      <p class="bookDescription body article font2">
        <p>Soul Modes presents ground-breaking new research into the motivation patterns of women. </p><p><br/><br/>Women are powerful, but they're also tired. This is the missing piece for so many - the ones who sometimes question themselves and their ability to deliver upon their dreams. Soul Modes is not the average self-help guide because it provides a framework that equips every woman to get to know herself, find her tripwires, and let her days be so much easier.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carlie Maree
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?87b94bb4